export const AGE_BREAKPOINTS = {
  child: 2,
}
